<template>
  <div class="info-message">
    <transition name="slideInRight">
      <div v-if="status">
        <b-alert :show="status" variant="info" class="alert-style">
          <div style="font-weight: bold">Trwa pobieranie danych z serwera.</div>
          <div class="text-style small">
            W zależności od predkości łącza może to potrwać kilka minut. Gdy wszystkie dane zostaną pobrane ten
            komunikat zniknie.
          </div>
          <bar-loader class="bar-style" color="#155724" loading="loading" size="150" size-unit="px"></bar-loader>
        </b-alert>
      </div>
    </transition>
  </div>
</template>

<script>
import { BarLoader } from '@saeris/vue-spinners';
export default {
  name: 'info-message',
  components: {
    BarLoader,
  },
  methods: {
    fakeData(startTime, delay) {
      function fakeDataFetch(startTime) {
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            console.log('Fetching data, please wait.');
            resolve(true);
          }, startTime);
        });
      }
      let dumbFetch = fakeDataFetch(startTime);
      dumbFetch
        .then(() => {
          console.log('Show');
          this.showAlert();
          return new Promise(function (resolve, reject) {
            setTimeout(function () {
              console.log('Got the goods, nice work.');
              resolve(true);
            }, delay);
          });
        })
        .then(() => {
          console.log('Hide');
          this.hideAlert();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    showAlert() {
      this.$store.commit('CHANGE_CACHE_STATUS', true);
    },
    hideAlert() {
      this.$store.commit('CHANGE_CACHE_STATUS', false);
    },
  },
  computed: {
    status() {
      console.log('this.$store.getters.cacheStatus', this.$store.getters.cacheStatus);
      return this.$store.getters.cacheStatus;
    },
  },
};
</script>
<style lang="scss" scoped>
.info-message {
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  opacity: 1;
  .alert-style {
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .text-style {
      text-align: left;
    }
    .text-style .small {
      font-size: small;
    }
    .bar-style {
      width: 100%;
    }
  }
}
.slideInRight-enter-active {
  animation: slideInRight 0.5s;
}
.slideInRight-leave-active {
  animation: slideInRight 0.5s reverse;
}
</style>
